class NotificationService {
  init = () => {}
}

export default new NotificationService()
